import gql from 'graphql-tag';

export default gql`
  mutation CancelSubscription($accountId: ID!) {
    cancelSubscription(accountId: $accountId) {
      __typename
    }
  }
`;
